import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import BookStay from "@/pages/BookStay";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import WorkWithUs from "@/pages/WorkWithUs";
import EventAdmin from "@/pages/EventAdmin";
import { Toaster } from "@/components/ui/sonner";

function MainLayout() {
  return (
    <>
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/book" element={<BookStay />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Routes>
            <Route path="/work-with-us" element={<WorkWithUs />} />
          <Route path="/admin/events" element={<EventAdmin />} />
            <Route path="/*" element={<MainLayout />} />
          </Routes>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
